import React from 'react';
import ChipIndicator from './ChipIndicator';

type TDisplayProps = {
    showChip?: boolean;
    displayText: string;
    value: string;
}

const DisplayBox = ({showChip = false, displayText, value}: TDisplayProps) => {
    return (
        <div className="tw-w-auto tw-h-auto tw-bg-gray-100 tw-rounded tw-border tw-border-zinc-300 tw-p-2">
            <div className='tw-flex tw-items-center tw-gap-2'>
                <label className='text-caption-style tw-text-[#747593]'>{displayText}</label>
                {showChip ? <ChipIndicator /> : null}
            </div>
            <label className={`tw-text-[#091E42] tw-mt-4 ${showChip ? 'tw-text-xl' : 'tw-font-semibold tw-text-base' } `}>{value}</label> 
        </div>
    );
}

export default DisplayBox;